import axios from '@axios'

export default {
  namespaced: true,
  state: {
    currentSignature: {},

    signatureAuthenticationModeDef: [
      {
        label: "SMS",
        subtitle: "Invio OTP tramite SMS",
        value: "otp_sms",
      },
      {
        label: "Email",
        subtitle: "Invio OTP tramite Email",
        value: "otp_email",
      },
    ],
    signatureStatusdef: {
      draft: {
        description: 'Bozza',
        badgeColor: 'primary',
      },
      approval: {
        description: 'In approvazione',
        badgeColor: 'primary',
      },
      rejected: {
        description: 'Rifiutata dall\'approvatore',
        badgeColor: 'warning',
      },
      ongoing: {
        description: 'In corso',
        badgeColor: 'info',
      },
      declined: {
        description: 'Rifiutata dal firmatario',
        badgeColor: 'warning',
      },
      expired: {
        description: 'Scaduta',
        badgeColor: 'warning',
      },
      deleted: {
        description: 'Sopspesa',
        badgeColor: 'danger',
      },
      canceled: {
        description: 'Cancellata',
        badgeColor: 'danger',
      },
      done: {
        description: 'Completata',
        badgeColor: 'success',
      },
    },
    signerStatusdef: {
      initiated: {
        description: 'Aggiunto alla richiesta',
        badgeColor: 'primary',
      },
      notified: {
        description: 'Notifica inviata',
        badgeColor: 'primary',
      },
      verified: {
        description: 'Verificato',
        badgeColor: 'warning',
      },
      consent_given: {
        description: 'Identità verificata',
        badgeColor: 'info',
      },
      processing: {
        description: 'Firma in corso',
        badgeColor: 'primary',
      },
      declined: {
        description: 'Firma rifiutata',
        badgeColor: 'warning',
      },
      signed: {
        description: 'Firma effettuata',
        badgeColor: 'success',
      },
      aborted: {
        description: 'Firma abortita',
        badgeColor: 'warning',
      },
      error: {
        description: 'Errore del servizio',
        badgeColor: 'danger',
      },
    },
    initStatusdef: {
      N: {
        description: 'Da avviare',
        badgeColor: 'primary',
      },
      C: {
        description: '2-Richiesta creata',
        badgeColor: 'warning',
      },
      S: {
        description: '3-Firmatari associati',
        badgeColor: 'warning',
      },
      F: {
        description: '4-Files caricati',
        badgeColor: 'warning',
      },
      I: {
        description: '5-Processo di firma avviato',
        badgeColor: 'success',
      },
    },
  },
  getters: {

    getSignatureAuthenticationModeDef(ctx) {
      return ctx.signatureAuthenticationModeDef
    },
    getSignatureStatusdef(ctx) {
      return ctx.signatureStatusdef
    },
    getSignerStatusdef(ctx) {
      return ctx.signerStatusdef
    },
    getinitStatusDef(ctx) {
      return ctx.initStatusdef
    },
  },
  mutations: {
    nuovaSignature(quotationId, signatureRequest) {
      // mutate state
      // state.count++
    },
  },
  actions: {
    fetchSignature(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/wsdlr/signature-requests/${id}`)
          .then(response => {
            this.currentSignature = response.signatureRequest
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },
    AddSignatureRequest(ctx, signatureRequest) {
      return new Promise((resolve, reject) => {
        axios
          .post('/wsdlr/signature-requests', { obj: signatureRequest })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    DeleteSignatureRequest(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .post('/wsdlr/signature-requests/delete', params)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    UpdateSigner(ctx, signer) {
      return new Promise((resolve, reject) => {
        axios
          .post('/wsdlr/signature-requests/signer', { obj: signer })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    InitiateSignatureProcess(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .post('/wsdlr/signature-requests/initiate', { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    DownloadRequestDocument(ctx, { signatureRequestId, documentId }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/wsdlr/signature-requests/document/${signatureRequestId}/${documentId}`)
          .then(response => {
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },
    DownloadSignatureRequestAuditTrails(ctx, { signatureRequestId }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/wsdlr/signature-requests/audit-trails/${signatureRequestId}`)
          .then(response => {
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },
  },
}
